import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BrandProvider } from "@/context/BrandContext";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import ArticlePage from "@/pages/ArticlePage";
import SearchPage from "@/pages/SearchPage";
import ArchivePage from "@/pages/ArchivePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AdvertisePage from "@/pages/AdvertisePage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import VerifyEmailPage from "@/pages/VerifyEmailPage";
import AccountPage from "@/pages/AccountPage";

function App() {
    return (
        <BrowserRouter>
            <BrandProvider>
                <AuthProvider>
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/category/:category" element={<CategoryPage />} />
                            <Route path="/category/:category/:subcategory" element={<CategoryPage />} />
                            <Route path="/article/:id" element={<ArticlePage />} />
                            <Route path="/search" element={<SearchPage />} />
                            <Route path="/archive" element={<ArchivePage />} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/register" element={<RegisterPage />} />
                            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                            <Route path="/reset-password" element={<ResetPasswordPage />} />
                            <Route path="/verify-email" element={<VerifyEmailPage />} />
                            <Route path="/account" element={<AccountPage />} />
                            <Route path="/advertise" element={<AdvertisePage />} />
                            <Route path="/privacy" element={<PrivacyPage />} />
                            <Route path="/terms" element={<TermsPage />} />
                            <Route path="/unsubscribe" element={<UnsubscribePage />} />
                        </Routes>
                    </Layout>
                    <Toaster />
                </AuthProvider>
            </BrandProvider>
        </BrowserRouter>
    );
}

export default App;
